<template>
  <div class="chat-messages">
    <div
      v-for="(message, index) in messages"
      :key="index"
      :class="['message', { assistant: message.role === 'assistant' }]"
    >
      <div class="message-avatar">
        <img
          v-if="message.role === 'assistant'"
          :src="getAgentAvatar(message.role)"
          alt="AI Avatar"
          style="width: 32px; height: 32px; border-radius: 50%"
        />
      </div>
      <div class="message-content">
        <p v-html="message.content"></p>
        <img
          v-if="message.image"
          :src="message.image"
          alt="Image téléchargée"
          style="max-width: 200px; margin-top: 0.5rem"
        />
        <div v-if="message.role === 'assistant'" class="message-actions">
          <span
            class="action-button"
            @click="copyMessage(message.content)"
            title="Copier le message"
          >
            📋
          </span>
        </div>
      </div>
    </div>
    <div v-if="isLoading" class="message assistant">
      <div class="message-avatar">
        <img
          :src="getAgentAvatar('assistant')"
          alt="AI Avatar"
          style="width: 32px; height: 32px; border-radius: 50%"
        />
      </div>
      <div class="message-content">
        <svg
          class="loading-indicator"
          viewBox="0 0 120 30"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="15" cy="15" r="15">
            <animate
              attributeName="r"
              from="15"
              to="15"
              begin="0s"
              dur="0.8s"
              values="15;9;15"
              calcMode="linear"
              repeatCount="indefinite"
            />
            <animate
              attributeName="fill-opacity"
              from="1"
              to="1"
              begin="0s"
              dur="0.8s"
              values="1;.5;1"
              calcMode="linear"
              repeatCount="indefinite"
            />
          </circle>
          <circle cx="60" cy="15" r="9" fill-opacity="0.3">
            <animate
              attributeName="r"
              from="9"
              to="9"
              begin="0s"
              dur="0.8s"
              values="9;15;9"
              calcMode="linear"
              repeatCount="indefinite"
            />
            <animate
              attributeName="fill-opacity"
              from="0.5"
              to="0.5"
              begin="0s"
              dur="0.8s"
              values=".5;1;.5"
              calcMode="linear"
              repeatCount="indefinite"
            />
          </circle>
          <circle cx="105" cy="15" r="15">
            <animate
              attributeName="r"
              from="15"
              to="15"
              begin="0s"
              dur="0.8s"
              values="15;9;15"
              calcMode="linear"
              repeatCount="indefinite"
            />
            <animate
              attributeName="fill-opacity"
              from="1"
              to="1"
              begin="0s"
              dur="0.8s"
              values="1;.5;1"
              calcMode="linear"
              repeatCount="indefinite"
            />
          </circle>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ChatMessages",
  props: {
    messages: {
      type: Array,
      required: true,
    },
    agents: {
      type: Array,
      required: true,
    },
    currentAgent: {
      type: String,
      required: true,
    },
    role: {
      type: String,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    function copyMessage(htmlContent) {
      // Extract text from HTML
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlContent, "text/html");
      const textContent = doc.body.textContent || "";

      navigator.clipboard
        .writeText(textContent)
        .then(() => {
          alert("Message copié dans le presse-papiers");
        })
        .catch((err) => {
          console.error("Impossible de copier le texte: ", err);
        });
    }

    function getAgentAvatar(role) {
      if (props.currentAgent && role === "assistant") {
        // Check if currentAgent exists and role is assistant
        const agent = props.agents.find(
          (agent) => agent.id === props.currentAgent
        );
        return agent ? agent.avatar : null;
      }
      return null; // No avatar for user messages or if no currentAgent
    }

    return {
      copyMessage,
      getAgentAvatar,
    };
  },
};
</script>

<style scoped>
.chat-messages {
  flex: 1;
  padding: 1rem;
  overflow-y: auto;
}

.message {
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
}

.message.assistant {
  background: #f9fafb;
  border-radius: 0.5rem;
}

.message-avatar {
  width: 32px;
  height: 32px;
  /* background: var(--secondary);  Remove the background color */
  border-radius: 50%;
  overflow: hidden; /* Ensure the image respects the border-radius */
}

.message-content {
  flex: 1;
  padding: 0.5rem 1rem;
}

.message-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 0.5rem;
}

.action-button {
  padding: 0.25rem;
  border-radius: 0.25rem;
  cursor: pointer;
  opacity: 0.7;
  transition: opacity 0.2s;
}

.action-button:hover {
  opacity: 1;
}

.loading-indicator {
  width: 60px;
  height: 30px;
}

.loading-indicator circle {
  fill: var(--secondary);
}
</style>
